import { render, staticRenderFns } from "./duIdentity.vue?vue&type=template&id=35dd5cc6&"
import script from "./duIdentity.vue?vue&type=script&lang=js&"
export * from "./duIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports